module.exports = __webpack_public_path__ + "static/media/Soil_profile_zone.ed351103.png";